module.exports = __webpack_public_path__ + "static/media/vector.f080b3b6.png";